export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.timeIndicator)+'" style="left: '+(props.percent)+'%"></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/controls/progress/templates/progressTimeIndicator.dot
// module id = 207
// module chunks = 0 1 2 3 4